import { CoreTypesComponents, ReportsTypesComponents } from '@affiliate-cabinet/types'
import { createEnumObject } from '@affstore-ds/types'
import { DateTime } from 'luxon'

export const CONTACT_LIST_VALUES = createEnumObject<CoreTypesComponents['schemas']['AlternativeContactQueryDto']['type']>({
  email: 'email',
  facebook: 'facebook',
  line: 'line',
  msteams: 'msteams',
  none: 'none',
  qq: 'qq',
  skype: 'skype',
  telegram: 'telegram',
  viber: 'viber',
  wechat: 'wechat',
  weibo: 'weibo',
  whatsapp: 'whatsapp',
})

export const CONTENT_MODE = createEnumObject<ReportsTypesComponents['schemas']['EditorModeEnum']>({
  editor: 'editor',
  plain: 'plain',
})

export const AFFSTORE_SITE_ID_LIST = [6, 12]

export const notSelectedItem = {
  'data-testid': 'not-selected',
  label: 'select.not-selected',
  value: '',
}

export const DATE_SHOW_FORMAT = 'dd.MM.yyyy'
export const DATE_SHOW_FULL_FORMAT = 'LLLL dd yyyy, HH:mm'
export const DATE_MODEL_FORMAT = 'yyyy-MM-dd'
export const DATE_MODEL_FORMAT_EXTENDED = 'yyyy-MM-DD HH:mm'
export const DATE_ISO_WITHOUT_ZONE = 'yyyy-MM-DDTHH:mm:ss'
export const DATE_HH_MM = 'H:mm'
export const DATE_TIMEZONE = 'ZZZZ'
export const DATE_MESSAGE_FORMAT = 'yyyy-MM-DD, HH:mm'
export const TABLE_PAGE_SIZES = [10, 25, 50, 100, 300]
export const DOZEN_TABLE_PAGE_SIZES = [12, 24, 48, 96, 300]
export const FORM_SEND_DELAY = 500
export const SHOW_MESSAGE_TIME = 10_000
export const SMS_CODE_EXPIRACTION_TIME = 300_000

export const minDateRaw = DateTime.now().set({ day: 1, hour: 0, millisecond: 0, minute: 0, month: 1, second: 0, year: 2013 })
export const minDate = minDateRaw.toJSDate()

export const URL_PLACEHOLDER = 'https://website.com'

export const affTrackSearchRegExp = /[^\w!$()*+,./=@-]+/gi

export const QS_ARRAY_LIMIT_VALUE = 10_000

export const NO_MANAGER_ID = 7454

export const MODAL_STATE_QUERY_KEY = 'action'

export const NOT_IDENTIFIED_COUNTRY_CODE = '--'

export const ZERO_VALUE = 0
export const EMPTY_TABLE_CELL_VALUE = '-'
export const ONE_VALUE = 1
export const EMPTY_STRING = ''
export const NOT_FOUND_INDEX = -1

export const RANK10 = 10

export const DEFAULT_PAGE_INDEX = 1
